exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dv-input-container{width:100%}.dv-input-container .form-control{width:80%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-input-container/dv-input-container.scss
// module id = DVWU
// module chunks = 0